<template>
  <div class="customer-info-container">
    <Breadcrumb
      :company="$store.state.user.company_uid"
      :project="$route.params.project_uid"
      :customer="$route.params.customer_uid"
    />

    <el-tabs v-model="tabActive" @tab-click="setTabActive">
      <el-tab-pane label="Customer Info" name="customer">
        <el-card class="box-card">
          <div class="edit-button">
            <el-button
              icon="el-icon-edit"
              type="primary"
              size="mini"
              @click="editCustomer()"
              >Edit</el-button
            >
          </div>
          <div class="customer-info">
            <el-row :gutter="80">
              <el-col :xs="24" :sm="24" :md="8" :lg="8">
                <div>
                  <svg-icon icon-class="team" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Customer Name"
                    placement="right"
                  >
                    <p>
                      <el-tag
                        >Customer Name: <b>{{ customerInfo.name }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
                <div v-if="customerInfo.name2">
                  <svg-icon icon-class="trading" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Trading Name"
                    placement="right"
                  >
                    <p>
                      <el-tag
                        >Trading Name: <b>{{ customerInfo.name2 }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon
                    :icon-class="
                      customerInfo.type === 'company' ? 'company' : 'customer'
                    "
                  />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Type"
                    placement="right"
                  >
                    <p>
                      <el-tag
                        >Type: <b>{{ customerInfo.type }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon icon-class="connect" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Status"
                    placement="right"
                  >
                    <p style="text-transform: capitalize">
                      <el-tag
                        :type="
                          customerInfo.status === 'active'
                            ? 'success'
                            : 'danger'
                        "
                        >Status: <b>{{ customerInfo.status }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon icon-class="introducer" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Introducer"
                    placement="right"
                  >
                    <p>
                      <el-tag
                        :type="
                          customerInfo.is_introducer === 'ON'
                            ? 'success'
                            : 'info'
                        "
                        >Introducer:
                        <b>{{ customerInfo.is_introducer }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>

              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8">
                <div>
                  <svg-icon icon-class="binary-code" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Distribution code"
                    placement="right"
                  >
                    <p>
                      <el-tag style="margin-right: 5px"
                        >Distribution code:
                        <b>{{ customerInfo.distribution_code }}</b></el-tag
                      >
                      <el-button
                        plain
                        type="primary"
                        size="small"
                        @click="dialogMoveVisible = true"
                        v-if="adminRole"
                        >Move</el-button
                      >
                    </p>
                  </el-tooltip>
                </div>
                
                <div>
                  <svg-icon icon-class="risk" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Risk"
                    placement="right"
                  >
                    <p style="text-transform: capitalize">
                      <el-tag
                      style="margin-right: 5px"
                        :type="customerInfo.riskBusiness ? 'danger' : 'info'"
                        >Risk:
                        <b>{{
                          customerInfo.riskBusiness ? "Yes" : "No"
                        }}</b></el-tag
                      >
                      <el-tag
                      style="margin-right: 5px"
                        :type="customerInfo.riskBusiness ? 'danger' : 'info'"
                        >Currency:
                        <b>{{
                          customerInfo.complianceChargeCurrency || "GBP"
                        }}</b></el-tag
                      >
                      <el-button
                        plain
                        type="warning"
                        size="small"
                        @click="editRiskStaus"
                        v-if="superAdmin"
                        >Edit</el-button
                      >
                    </p>
                  </el-tooltip>
                </div>
                <div v-if="adminRole">
                  <contract-list ref="contractList" v-if="customerInfo.enduser_id" :customerUID="customerInfo.enduser_id"/>
                </div>
                <div v-if="debtSum">
                  <svg-icon icon-class="debt" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Debt"
                    placement="right"
                  >
                    <p style="text-transform: capitalize">
                      <el-tag :type="'danger'"
                        >Debt: <b>{{ debtSum }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8">
                
                <div>
                  <svg-icon icon-class="collected" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Vender"
                    placement="right"
                  >
                    <p>
                      <el-tag
                        >Vender: <b>{{ venderType[customerInfo.vender_type] }}</b></el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <BankAccountManager
          :projectUID="projectUID"
          :customerUID="customerUID"
          :readonlyMode="bankRole"
          :showAccountNumber="false"
          apiMode="customer"
          v-on:contract-changed="contractChanged"
        />
      </el-tab-pane>

      <el-tab-pane label="Beneficiaries" name="beneficiary">
        <BeneficiaryManager :customerUID="customerUID" />
      </el-tab-pane>
      <el-tab-pane
        label="Introducer"
        name="introducer"
        v-if="customerInfo.is_introducer != 'N/A' && adminRole"
      >
        <Introducer :projectUID="projectUID" />
      </el-tab-pane>
      <el-tab-pane label="Rules" name="rules" v-if="superAdmin || userFirewallSetting">
        <customer-rules v-if="customerInfo.uuid2" :plusUID="customerInfo.uuid2" />
      </el-tab-pane>
      <el-tab-pane label="Blacklist" name="blacklist" v-if="superAdmin || userFirewallSetting">
        <customer-blacklist v-if="customerInfo.uuid2" :plusUID="customerInfo.uuid2" />
      </el-tab-pane>
      <el-tab-pane label="Whitelist" name="whitelist" v-if="superAdmin || userFirewallSetting">
        <customer-whitelist v-if="customerInfo.uuid2" :plusUID="customerInfo.uuid2" />
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="Move this customer to Project"
      :visible.sync="dialogMoveVisible"
      width="417px"
      center
    >
      <el-card
        class="box-card select-company-project"
        style="overflow: inherit"
      >
        <el-form :inline="true">
          <el-form-item label="Company">
            <model-list-select
              :list="dataCompany"
              v-model="company"
              option-value="uid"
              option-text="company_name"
              placeholder="All"
              @input="getProjectData()"
            >
            </model-list-select>
          </el-form-item>
          <el-form-item label="Project">
            <model-list-select
              :list="dataProject"
              v-model="project"
              option-value="uid"
              option-text="project_name"
              placeholder="All"
              @input="projectActive"
            >
            </model-list-select>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMoveVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="move_loading" @click="submitMoveProject()"
          >Confirm</el-button
        >
      </span>
    </el-dialog>

    <CustomerRiskUpdate ref="customer-risk-dialog"  v-on:submited="customerRiskUpdated"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCustomerBy } from "@/api/customer";
import { getDebtCustomerSummary } from "@/api/debt";
import BankAccountManager from "@/views/bank-account/components/bank-account-manager";
import Breadcrumb from "@/components/Breadcrumb";
import BeneficiaryManager from "@/views/beneficiary/components/beneficiary-manager";
import CustomerRules from "@/views/rules/components/rules-customer";
import CustomerBlacklist from "@/views/blacklist/components/blacklist-customer";
import CustomerWhitelist from "@/views/whitelist/components/whitelist-customer";
import Introducer from "@/views/introducer/components/introducer";
import { ModelListSelect } from "vue-search-select";
import { getCompany } from "@/api/company";
import { getProjectByCompany } from "@/api/project";
import { moveProject } from "@/api/utility";
import CustomerRiskUpdate from "@/views/customer/components/customer-risk-dialog-form";
import ContractList from './contract-list.vue';
export default {
  components: {
    BankAccountManager,
    Breadcrumb,
    BeneficiaryManager,
    CustomerRules,
    Introducer,
    CustomerBlacklist,
    ModelListSelect,
    CustomerWhitelist,
    CustomerRiskUpdate,
    ContractList
  },
  computed: {
    ...mapGetters(["company_name", "company_uid"]),
    bankRole() {
      return this.roleAuth([this.role.user]);
    },
    adminRole() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
    superAdmin() {
      return this.roleAuth([this.role.spadmin]);
    },
    userFirewallSetting(){
      return this.$store.state.user.flag_firewallsetting;
    },
  },
  data() {
    return {
      projectUID: this.$route.params.project_uid,
      customerUID: this.$route.params.customer_uid,
      customerInfo: {},
      tabActive: this.$route.query.tab || "customer",
      dialogFormVisible: false,
      move_loading: false,
      dialogEditRiskStatus: false,
      debtSum: "",
      dialogMoveVisible: false,
      dataCompany: [],
      dataProject: [],
      company: "",
      project: "",
      venderType: {
        "railsbank": "Railsbank",
        "internal": "Internal",
        "abwallet": "ABWallet",
        "ifx": "Barclays",
        "lloyds": "Lloyds Bank",
      }
    };
  },
  methods: {
    contractChanged() {
      if (this.$refs.contractList) {
        this.$refs.contractList.reload();
      }
    },
    getCustomerInfo() {
      getCustomerBy(this.customerUID).then(({ result, data }) => {
        if (result && data) {
          this.customerInfo = data;
          this.getDebtCustomerSummary(this.customerInfo.enduser_id);
        }
      });
    },
    gotoProject() {
      const route = this.$route;
      if (route.name === "ProjectCustomer") {
        window.location = `/project/${route.params.project_uid}?tab=project`;
      } else {
        this.$router.push(`/project/${route.params.project_uid}`);
      }
    },
    setTabActive(tab) {
      this.$router.push("?tab=" + tab.name);
    },

    getDebtCustomerSummary(enduser_id) {
      getDebtCustomerSummary(enduser_id).then(({ result, data }) => {
        if (result) {
          this.debtSum = data ? data.all.amountFormat : "";
        }
      });
    },

    editCustomer() {
      let version = this.customerInfo.versioning == "2" ? "/v2" : "";
      let url = `/customer${version}/edit/${this.customerUID}/${this.customerInfo.type}?ref=info`
      this.$router.push(url);
    },
    reloadMoveCustomer() {
      this.$router.push(
        `/customer/view/${this.project}/${this.customerInfo.enduser_id}?tab=customer`
      );
    },
    onSubmited() {
      this.getCustomerInfo();
    },
    getCompanyData() {
      getCompany().then(({ result, data }) => {
        if (result) {
          this.dataCompany = data;
          this.getProjectData();
        }
      });
    },
    getProjectData() {
      this.project = "";
      this.dataProject = [];
      getProjectByCompany(this.company).then(({ result, data }) => {
        if (result) {
          this.dataProject = data;
        }
      });
    },
    projectActive(value) {
      this.project = value;
    },
    submitMoveProject() {
      // console.log(this.project);
      // console.log(this.customerInfo.uuid2);
      if (this.move_loading) return;
      if (!this.project) {
        this.$alert("Please select project", "Message");
      } else {
        this.move_loading = true;
        var data = {
          plusuid: this.customerInfo.uuid2,
          projectuid: this.project,
        };
        moveProject(data).then(({ result, message }) => {
          this.move_loading = false;
          if (result) {
            this.dialogMoveVisible = false;
            this.reloadMoveCustomer();
          } else {
            this.$notify({
              title: "Error",
              message: message,
              type: "error",
              duration: 2000,
            });
          }
        }).catch(() => {
          this.move_loading = false;
        });
      }
    },
    editRiskStaus(){
      this.$refs['customer-risk-dialog'].show(this.customerUID, this.$route.params.project_uid)
    },
    customerRiskUpdated(data){
      this.customerInfo.riskBusiness = data.riskfeeoption
      this.customerInfo.complianceChargeCurrency = data.complianceChargeCurrency
    },

  },
  created() {
    this.company = this.company_uid;
    if (this.adminRole) this.getCompanyData();
    this.getCustomerInfo();
  },
};
</script>

<style lang="scss">
.customer-info-container {
  .customer-info {
    margin-top: 20px;
    div .svg-icon {
      font-size: 32px;
      text-align: center;
      margin: 5px 15px;
      vertical-align: middle;
    }

    div p {
      display: inline-block;
      color: #303133;
      vertical-align: middle;
      margin: 0;
    }
    div p .el-tag {
      font-size: 14px;
    }
  }

  .edit-button {
    float: right;
  }

  .select-company-project {
    .el-form-item__content {
      margin-right: 20px;
      min-width: 330px;
    }
  }
}
</style>